import { CgMenuBoxed } from 'react-icons/cg';
import styled from 'styled-components';
import { blueGray, outlineGray, primaryColor } from '../../config/colors';
import Button from '../Button';

const STYLE_CONFIG = {
  WrapperWidth: '85%',
  CollapseToggleWidth: '36px',
  LeftPanelWidth: '400px',
};
export const Container = styled.div`
  border-right: 1px solid ${outlineGray};
  background-color: white;
  display: flex;
  width: auto;
  height: calc(100vh - 135px);
  position: fixed;
  top: 135px;

  left: ${({ isCollapsed }) => (isCollapsed ? `calc(-${STYLE_CONFIG.LeftPanelWidth} + 20px)` : `0px`)};

  transition: left 0.3s ease-out;

  display: grid;
  grid-template-columns: ${STYLE_CONFIG.LeftPanelWidth} auto;
  z-index: ${({ zIndex }) => zIndex || '100'};
`;

export const LeftPanel = styled.div`
  border-right: 1px solid ${outlineGray};
  overflow-y: auto;
`;
export const RightPanel = styled.div`
  overflow-y: auto;
  max-width: 90vw;
`;

export const MenuIconBtn = styled(Button).attrs(() => ({
  wrapperStyle: {
    width: '2.375rem',
    height: '2.375rem',
    backgroundColor: 'transparent',
    borderRadius: '0.5rem',
    boxShadow: 'none',
    transform: 'rotate(90deg)',
    position: 'relative',
    left: '-7px',
  },

  icon: CgMenuBoxed,
  iconProps: {
    color: primaryColor,
    size: '1.6rem',
  },
}))``;

export const CollapseToggleContainer = styled.div`
  border-radius: 8px;

  border: 2px solid ${outlineGray};
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;

  position: absolute;
  right: -35px;
  top: 0px;
  background-color: white;
  width: ${STYLE_CONFIG.CollapseToggleWidth};
  height: 123px;
  padding: 10px 0px;
  background-color: white;
  border-top: none;
  border-left: none;

  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: background-color 0.3s ease-out;

  & label {
    cursor: inherit;
    margin-top: 6px;
    transform: rotate(90deg);
    text-align: center;
    position: relative;
    left: -4px;
  }
`;

export const SlotsContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 70vw;
  min-width: 70vw;
  width: 70vw;
  padding: 0px 16px;
  position: relative;
`;

export const Slot = styled.div`
  padding-right: 10px;
  width: 100%;
`;
